module.exports = __webpack_public_path__ + "fonts/fa-regular-400.b91d376b.woff2";